var angular = require('angular');
var PortalAPI = require('../api').Portal;
var Promise = require('bluebird');
var Auth = require('../../common/auth/index.js');
// var FacebookAuth = require('../../../../shared/facebook/auth.js');

module.exports = LoginController;

function LoginController($scope, $sce, $stateParams, appDetails, $location) {

  $scope.app = appDetails;
  $scope.login = {email: '', password: ''};
  $scope.signupUrl = '/signup';
  $scope.configurableMessage = "";

  $scope.displayConfigurableMessage = function(){
    return $scope.configurableMessage != "";
  };


  PortalAPI
    .getLoginPageMessage()
    .then(function(result) {
      var treatedResult = $sce.trustAsHtml(result);
      $scope.configurableMessage = treatedResult;
    });

  var originator = $location.search().originator;
  if (originator) {
    $scope.signupUrl = $scope.signupUrl + '?originator=' + originator;
  }
  for (qsKey in $location.search()) {
    if (qsKey.indexOf('lp_') != -1) {
      val = $location.search()[qsKey];
      $scope.signupUrl = $scope.signupUrl + '&' + qsKey + '=' + encodeURIComponent(val);
    }
  }

  $scope.submitLogin = function(){
    $scope.submitted = true;
    return PortalAPI
      .login($stateParams, {
        email: $scope.login.email,
        password: $scope.login.password
      })
      .then(function(resp){
        $scope.error = null;
        if (resp.redirect) {
          if (originator) {
            window.location = resp.redirect + "&originator=" + originator;
          }
          else
            window.location = resp.redirect;
        }
      })
      .catch(function(resp){
        $scope.error = resp.body.error;
      })
      .finally(function(){
        $scope.submitted = false;
      })
  }

  // $scope.loginWithFacebook = function(){
  //   FacebookAuth.login(function(token) {
  //     $scope.submitFacebookLogin(token);
  //   });
  // }

  $scope.submitFacebookLogin = function(accessToken){
    return PortalAPI
      .login($stateParams, {
        facebook: accessToken
      })
      .then(function(resp){
        if (resp.redirect) window.location = resp.redirect;
      })
  }

  // FacebookAuth.init();

   var prepop_fb_token = $location.search().fb_token;
   if (prepop_fb_token) {
     $scope.submitFacebookLogin(prepop_fb_token);
   }
}
